<template>
<nav class="navbar navbar-expand-lg navbar-light bg-white" style="box-shadow:2px 2px 5px #ccc">
      <div class="container">
        
        <!-- Brand -->
        <a class="navbar-brand" href="/">
          <img src="/static/images/logo.png" class="navbar-brand-img" alt="..."> 
        </a>
    
        <!-- Toggler -->
        <button class="navbar-toggler" id="menuButton" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    
        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="navbarCollapse" style="justify-content:right;position:relative;top:15px">
    
          <div style="position:absolute;right:20px;top:-30px;font-size:14px;color:#666">
             
            <i class="bi bi-envelope-fill" style="color:#526193;margin-right:5px"></i> cliff@adachemicals.com
          
            <img src="/static/images/en.jpeg" style="width:25px;height:18px;cursor: pointer;margin-left:10px" @click="changeLocale('en')"/>
            <img src="/static/images/zh.jpeg" style="width:25px;height:18px;cursor:pointer;margin-left:3px"  @click="changeLocale('zh')" />
           
          
          </div>
    
          <!-- Navigation -->
          <ul class="navbar-nav ms-auto">
            <li class="nav-item dropdown">
              <a class="nav-link" id="navbarLandings" @click="jump('/')">
                {{$t('menu_home')}}
              </a>
              
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" id="aboutUsMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{$t('menu_about')}} <i class="bi bi-chevron-down" style="font-size:12px;font-weight:bold"></i>
              </a>
              <ul class="dropdown-menu" aria-labelledby="aboutUsMenu">
                <li> <a class="dropdown-item" @click="jump('aboutus')">{{$t('menu_about_company')}}</a></li>
                <li> <a class="dropdown-item" @click="jump('team')">{{$t('menu_about_team')}}</a></li>
                <li> <a class="dropdown-item" @click="jump('customer')">{{$t('menu_about_customer')}}</a></li>
                <li> <a class="dropdown-item" @click="jump('partner')">{{$t('menu_about_partner')}}</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" id="productMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{$t('menu_product')}} <i class="bi bi-chevron-down" style="font-size:12px;font-weight:bold"></i>
              </a>
              <ul class="dropdown-menu" aria-labelledby="productMenu">
                <li> <a class="dropdown-item" @click="jump1('1')">{{$t('menu_product_1')}}</a></li>
                <li> <a class="dropdown-item" @click="jump1('2')">{{$t('menu_product_2')}}</a></li>
                <li> <a class="dropdown-item" @click="jump1('3')">{{$t('menu_product_3')}}</a></li>
                
                
                <li> <a class="dropdown-item" @click="jump1('4')">{{$t('menu_product_4')}}</a></li>
                <!-- <li> <a class="dropdown-item" @click="jump1('5')">Food Additives</a></li> -->
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" id="navbarAccount" @click="jump('service')">
                {{$t('menu_service')}}
              </a>
              
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" id="navbarAccount" @click="jump('contactus')">
                {{$t('menu_contact')}}
              </a>
              
            </li>
           

            

            
          </ul>
    
        
        </div>
    
      </div>
</nav>
</template>

<script>

import bus from '../util/bus';
export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
        
    },
    methods:{
        jump(url){
          this.$router.push(url);
        },
        jump1(cate){
            this.$router.push('category?id='+cate);
            bus.$emit('changecategory');
        },
        changeLocale(locale){
          this.$i18n.locale = locale;
          window.localStorage.setItem('locale',locale);
        }
    },
    data(){
        return{
           
        }
    }
};
</script>

<style>
.navbar-brand-img{
    width: 150px;
    height:auto;
}

.nav-item{
  margin:0px 10px;
  font-weight:bold;
}

a{
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// navbar.vue?5527a5cf